export enum EmployeeFeedbackVisibilityMode {
  Hidden = 0,
  ManagerDecides = 1,
  AlwaysVisible = 2,
}

export type EmployeeFeedbackSettingsModel = {
  mode: EmployeeFeedbackVisibilityMode;
};
